export default __webpack_public_path__ + "static/media/shoot.4b918d10.gif";